// extracted by mini-css-extract-plugin
export default {"profileWrapper":"styles_profileWrapper__tuii9","cardHeader":"styles_cardHeader__HKNVC","avatarWrapper":"styles_avatarWrapper__JN6Bt","avatar":"styles_avatar__aN4yT"};